import { FC } from 'react';
import { Card, Col, Grid, Image, Row, Typography } from 'antd';
import IconCustom from 'src/components/Icon/Custom';
import { formatDateListArticels } from 'src/utils/func/format-date';
import classes from './article.module.less';
interface CardArticleInterface {
  data?: any;
}
const CardArticleHB2: FC<CardArticleInterface> = artikel => {
  const {
    xs
  } = Grid.useBreakpoint();
  const lengths = xs ? 35 : 45;
  const lengths2 = xs ? 60 : 70;
  const truncateString = (str: string) => {
    if (str?.length > lengths) {
      return `${str.substring(0, lengths)}...`;
    }
    return str;
  };
  const truncateString2 = (str: string) => {
    if (str?.length > lengths2) {
      return `${str.substring(0, lengths2)}...`;
    }
    return str;
  };
  return <div className={classes.containerCard}>
			{/* <h1 className={classes.textH2}>
    Kumpulan Artikel <span className={classes.textCategory}>Hallobumil</span>
    </h1> */}
			<Row>
				{artikel?.data?.artikel?.map((item: any) => {
        const dataPhase = item.type === 'pregnancy' ? 'kehamilan' : item.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
        return <Col sm={8} md={8} lg={8} xl={8} xs={24} key={item.id}>
							<a href={`/${dataPhase}/${item.slug}`}>
								<Card size="small" hoverable={false} className={classes.cards} cover={<Image alt="example" src={item.media_images.original} className={classes.imageContainer} style={{
              width: '367px',
              height: '203px',
              borderRadius: '20px',
              objectFit: 'cover',
              cursor: 'pointer'
            }} preview={false} loading='lazy' />}>
									<Typography className={classes.title}>{truncateString(item.title)}</Typography>

									<Row>
										<Col className="d-flex align-items-center" style={{
                  marginLeft: xs ? '-5px' : '-15px'
                }}>
											<Typography className="fs-12 fs-md-14">
												Diterbitkan pada {formatDateListArticels(item.publish_date)}
											</Typography>
										</Col>
									</Row>
									<Row>
										<Col className="d-flex align-items-center" style={{
                  marginLeft: xs ? '-5px' : '-15px'
                }}>
											<Typography className="fs-12 fs-md-14" style={{
                    color: '#9ca3aa'
                  }}>
												{truncateString2(item.short_desc)}
											</Typography>
										</Col>
									</Row>
									<Row>
										<Col className="d-flex align-items-center" style={{
                  marginLeft: xs ? '-5px' : '-15px'
                }}>
											<IconCustom iconName="heart" />
											<Typography className="fs-12 fs-md-14 ml-2" style={{
                    color: '#9ca3aa'
                  }}>
												{item.total_like}
											</Typography>
										</Col>
										<Col className="d-flex align-items-center" style={{
                  marginLeft: '10px'
                }}>
											<IconCustom iconName="comment" />
											<Typography className="fs-12 fs-md-14 ml-2" style={{
                    color: '#9ca3aa'
                  }}>
												{item.total_comment}
											</Typography>
										</Col>
									</Row>
								</Card>
							</a>
						</Col>;
      })}
			</Row>
		</div>;
};
export default CardArticleHB2;